import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MissionsTabs({ pendingCount = 0 }) {
  const { t } = useTranslation();
  const linkCls = ({ isActive }) =>
    `flex-1 text-center py-2.5 rounded-full text-sm font-medium transition-all ${
      isActive ? "bg-[#1A4D2E] text-white shadow-sm" : "text-[#1A4D2E] hover:bg-white"
    }`;
  return (
    <div
      className="bg-[#E8F0EA] border border-[#1A4D2E]/10 rounded-full p-1 flex items-center gap-1 max-w-md mx-auto lg:mx-0"
      data-testid="missions-tabs"
    >
      <NavLink to="/missions" end className={linkCls} data-testid="tab-missions-available">
        {t("missions.available")}
      </NavLink>
      <NavLink to="/my-missions" className={linkCls} data-testid="tab-missions-mine">
        <span className="inline-flex items-center gap-2">
          {t("missions.mine")}
          {pendingCount > 0 && (
            <span className="bg-[#E3655B] text-white text-[10px] font-semibold rounded-full min-w-[18px] h-[18px] grid place-items-center px-1">
              {pendingCount}
            </span>
          )}
        </span>
      </NavLink>
    </div>
  );
}
